import React, { useState, useEffect } from 'react'
import { authUser, projectFirestore } from '../firebase/config'
import { useAuth } from '../contexts/AuthContext'

import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container'
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';


const Headeradmin = () => {
    const { userProfile, logout } = useAuth();
    const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
    const [siteSettings, setSiteSettings] = useState({});

    useEffect(() => {
        const unsub = projectFirestore.collection('settings').doc('site')
            .onSnapshot((doc) => {
                if (doc.exists) setSiteSettings(doc.data());
            });
        return () => unsub();
    }, []);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
        localStorage.setItem('darkMode', darkMode);
    }, [darkMode]);

    const initial = (userProfile?.displayName || userProfile?.email || '?')[0].toUpperCase();
    const logoSrc = darkMode && siteSettings.logoDarkUrl
        ? siteSettings.logoDarkUrl
        : (siteSettings.logoUrl || '/logoa.svg');
    const hasCustomDarkLogo = darkMode && siteSettings.logoDarkUrl;

    return (
<Navbar className='admin-header sticky-top' expand="lg" >
    <Container>
    <Navbar.Brand href="/">
        <img
            alt="حكاية ضوء"
            src={logoSrc}
            width="36"
            height="36"
            className={`d-inline-block align-top${hasCustomDarkLogo ? ' has-dark-logo' : ''}`}
            style={{borderRadius: 8, marginLeft: 8}}
        />
        لوحة التحكم
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
            <Nav.Link href="/"><i className="fas fa-home me-1"></i> الرئيسية</Nav.Link>
            <Nav.Link href="gallery"><i className="fas fa-images me-1"></i> المعرض</Nav.Link>
            <Nav.Link href="about-us"><i className="fas fa-info-circle me-1"></i> عن الموقع</Nav.Link>
            <Nav.Link href="contact-us"><i className="fas fa-comment-alt me-1"></i> تواصل معنا</Nav.Link>
        </Nav>
        <div className="d-flex align-items-center gap-2">
            <div className="admin-user-badge">
                <div className="user-avatar">{initial}</div>
                <span>{userProfile?.displayName || userProfile?.email}</span>
            </div>
            <button className="dark-toggle" onClick={() => setDarkMode(!darkMode)}
                title={darkMode ? 'الوضع النهاري' : 'الوضع الليلي'}>
                {darkMode ? '☀️' : '🌙'}
            </button>
            <button className="btn btn-sm btn-outline-light" onClick={logout}>
                <i className="fas fa-sign-out-alt me-1"></i> خروج
            </button>
        </div>
    </Navbar.Collapse>
    </Container>
    </Navbar>
)}

export default Headeradmin;